import React, { ReactNode } from 'react'
import { FlexBox } from 'components/Box'

import { Caption1, Heading3 } from '../ui/typography'

import styles from './InfoScreen.module.scss'

export interface InfoScreenAction {
  text: string
  onClick?: () => void
  variant?: 'primary' | 'secondary' | 'alert' | 'bordered' | 'borderless'
  icon?: ReactNode
}

export interface InfoScreenProps {
  title: string
  description?: string
  instructions?: string
  className?: string
  style?: React.CSSProperties
}

const InfoScreen: React.FC<InfoScreenProps> = ({
  title,
  description,
  instructions,
  className,
  style,
}) => {
  return (
    <FlexBox
      className={`${styles.infoScreen} ${className || ''}`}
      style={style}
      alignItems='center'
      justifyContent='center'
    >
      <FlexBox
        className={styles.infoScreen__content}
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
      >
        <Heading3 className={styles.infoScreen__title}>{title}</Heading3>

        {description && (
          <Caption1 className={styles.infoScreen__description}>{description}</Caption1>
        )}

        {instructions && (
          <Caption1 className={styles.infoScreen__instructions}>{instructions}</Caption1>
        )}
      </FlexBox>
    </FlexBox>
  )
}

export default InfoScreen
